import { Product } from '@/types/Product';

const getProductFinish = (product: Product): string | undefined => {
  return product?.selectedTraits?.find((trait) => trait?.name === 'Color')
    ?.value;
};

export default getProductFinish;
